import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },*/
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
     key: 'fullName',
     field: FIELDS.FULL_NAME,
     title: 'Contact Name',
     label: 'Contact Name',
     cell: 'multipleNavigation',
     sortable: true,
     hidden: false,
     width: 150,
     locked: true
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
     cell: 'multipleNavigation'
  },{
     key: 'title',
     field: FIELDS.TITLE,
     title: 'Title',
     label: 'Title',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'gender',
     field: FIELDS.GENDER,
     title: 'Gender',
     label: 'Gender',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'location',
     field: FIELDS.LOCATION,
     title: 'Location',
     label: 'Location',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'locationPhone',
     field: FIELDS.LOCATION_PHONE,
     title: 'Location Phone',
     label: 'Location Phone',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'email1',
     field: FIELDS.EMAIL1,
     title: 'Email 1',
     label: 'Email 1',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'direct',
     field: FIELDS.DIRECT,
     title: 'Direct',
     label: 'Direct',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isPrimary',
     field: FIELDS.IS_PRIMARY,
     title: 'Primary',
     label: 'Primary',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'main',
     field: FIELDS.MAIN,
     title: 'Main',
     label: 'Main',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'mobile',
     field: FIELDS.MOBILE,
     title: 'Mobile',
     label: 'Mobile',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'phone1Ext',
     field: FIELDS.PHONE1_EXT,
     title: 'Ext',
     label: 'Ext',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'comment',
     field: FIELDS.COMMENT,
     title: 'Comment',
     label: 'Comment',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyRating',
     field: FIELDS.COMPANY_RATING,
     title: 'Company Rating',
     label: 'Company Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorType',
     field: FIELDS.VENDOR_TYPE,
     title: 'Vendor Type',
     label: 'Vendor Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'firstName',
     field: FIELDS.FIRST_NAME,
     title: 'First Name',
     label: 'First Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lastName',
     field: FIELDS.LAST_NAME,
     title: 'Last Name',
     label: 'Last Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dob',
     field: FIELDS.DOB,
     title: 'DOB',
     label: 'DOB',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'email2',
     field: FIELDS.EMAIL2,
     title: 'Email 2',
     label: 'Email 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'phone1',
     field: FIELDS.PHONE1,
     title: 'Phone 1',
     label: 'Phone 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'phone2TypeName',
     field: FIELDS.PHONE2_TYPE_NAME,
     title: 'Phone 2 Type',
     label: 'Phone 2 Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'phone2',
     field: FIELDS.PHONE2,
     title: 'Phone 2',
     label: 'Phone 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'phone2Ext',
     field: FIELDS.PHONE2_EXT,
     title: 'Phone 2 Ext',
     label: 'Phone 2 Ext',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingState',
     field: FIELDS.BILLING_STATE,
     title: 'Billing State',
     label: 'Billing State',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingCountry',
     field: FIELDS.BILLING_COUNTRY,
     title: 'Billing Country',
     label: 'Billing Country',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingState',
     field: FIELDS.SHIPPING_STATE,
     title: 'Shipping State',
     label: 'Shipping State',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingCountry',
     field: FIELDS.SHIPPING_COUNTRY,
     title: 'Shipping Country',
     label: 'Shipping Country',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'accounting',
     field: FIELDS.ACCOUNTING,
     title: 'Accounting',
     label: 'Accounting',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'purchasing',
     field: FIELDS.PURCHASING,
     title: 'Purchasing',
     label: 'Purchasing',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sales',
     field: FIELDS.SALES,
     title: 'Sales',
     label: 'Sales',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'doNotEmail',
     field: FIELDS.DO_NOT_EMAIL,
     title: 'Do Not Email',
     label: 'Do Not Email',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'doNotCall',
     field: FIELDS.DO_NOT_CALL,
     title: 'Do Not Call',
     label: 'Do Not Call',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'linkin',
     field: FIELDS.LINKIN,
     title: 'Linkin',
     label: 'Linkin',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'skype',
     field: FIELDS.SKYPE,
     title: 'Skype',
     label: 'Skype',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'twitter',
     field: FIELDS.TWITTER,
     title: 'Twitter',
     label: 'Twitter',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'facebook',
     field: FIELDS.FACEBOOK,
     title: 'Facebook',
     label: 'Facebook',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'xing',
     field: FIELDS.XING,
     title: 'Xing',
     label: 'Xing',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isAvl',
     field: FIELDS.IS_AVL,
     title: 'Is AVL',
     label: 'Is AVL',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taskType',
     field: FIELDS.TASK_TYPE,
     title: 'Task Type',
     label: 'Task Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taskStatus',
     field: FIELDS.TASK_STATUS,
     title: 'Task Status',
     label: 'Task Status',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taskPriority',
     field: FIELDS.TASK_PRIORITY,
     title: 'Task Priority',
     label: 'Task Priority',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taskSubject',
     field: FIELDS.TASK_SUBJECT,
     title: 'Task Subject',
     label: 'Task Subject',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taskDue',
     field: FIELDS.TASK_DUE,
     title: 'Task Due',
     label: 'Task Due',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
